import { render, staticRenderFns } from "./NewImageset.vue?vue&type=template&id=33f42c6c"
import script from "./NewImageset.vue?vue&type=script&lang=js"
export * from "./NewImageset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports